const nonOrganic = '#2E8DFB';

export const muiPalette = {
  palette: {
    text: {
      primary: '#220D4E',
      secondary: '#514B5F',
      disabled: '#ABB2C3',
      hint: '#6E6F7E',
      link: '#036DEB'
    },
    grey: {
      50: '#F9FAFC',
      100: '#F5F6F8',
      200: '#EFF0F2',
      300: '#E1E2E4',
      400: '#BFBFC1',
      500: '#A0A1A3',
      600: '#777879',
      700: '#636365',
      800: '#434446',
      900: '#222324'
    },
    red: {
      50: '#FFF5F5',
      100: '#FFE3E3',
      200: '#FFC9C9',
      300: '#FFA8A8',
      400: '#FF8787',
      500: '#FF6B6B',
      600: '#FA5252',
      700: '#F03E3E',
      800: '#E03131',
      900: '#C92A2A'
    },
    pink: {
      50: '#FFF0F6',
      100: '#FFDEEB',
      200: '#FCC2D7',
      300: '#FAA2C1',
      400: '#F783AC',
      500: '#F06595',
      600: '#E64980',
      700: '#D6336C',
      800: '#C2255C',
      900: '#A61E4D'
    },
    grape: {
      50: '#F8F0FC',
      100: '#F3D9FA',
      200: '#EEBEFA',
      300: '#E599F7',
      400: '#DA77F2',
      500: '#CC5DE8',
      600: '#BE4BDB',
      700: '#AE3EC9',
      800: '#9C36B5',
      900: '#862E9C'
    },
    violet: {
      50: '#F3F0FF',
      100: '#E5DBFF',
      200: '#D0BFFF',
      300: '#B197FC',
      400: '#9775FA',
      500: '#845EF7',
      600: '#7950F2',
      700: '#7048E8',
      800: '#6741D9',
      900: '#5F3DC4'
    },
    indigo: {
      50: '#EDF2FF',
      100: '#DBE4FF',
      200: '#BAC8FF',
      300: '#91A7FF',
      400: '#748FFC',
      500: '#5476FD',
      600: '#4A3BF8',
      700: '#0703D8',
      800: '#0F0AE2',
      900: '#001DA8'
    },
    blue: {
      50: '#E7F5FF',
      100: '#D0EBFF',
      150: '#C0E0FC',
      200: '#A5D8FF',
      250: '#95C9F9',
      300: '#74C0FC',
      350: '#74B5F4',
      400: '#4DABF7',
      450: '#5CA5EE',
      500: '#339AF0',
      600: '#0081F0',
      700: '#006FD2',
      800: '#005FB6',
      900: '#004D95'
    },
    cyan: {
      50: '#E3FAFC',
      100: '#C5F6FA',
      200: '#99E9F2',
      300: '#66D9E8',
      400: '#3BC9DB',
      500: '#22B8CF',
      600: '#15AABF',
      700: '#1098AD',
      800: '#0C8599',
      900: '#0B7285'
    },
    teal: {
      50: '#E6FCF5',
      100: '#C3FAE8',
      200: '#96F2D7',
      300: '#63E6BE',
      400: '#38D9A9',
      500: '#20C997',
      600: '#12B886',
      700: '#0CA678',
      800: '#099268',
      900: '#087F5B'
    },
    green: {
      50: '#EBFBEE',
      100: '#D3F9D8',
      200: '#B2F2BB',
      300: '#8CE99A',
      400: '#69DB7C',
      500: '#51CF66',
      600: '#40C057',
      700: '#37B24D',
      800: '#2F9E44',
      900: '#2B8A3E'
    },
    lime: {
      50: '#F4FCE3',
      100: '#E9FAC8',
      200: '#D8F5A2',
      300: '#C0EB75',
      400: '#A9E34B',
      500: '#94D82D',
      600: '#82C91E',
      700: '#74B816',
      800: '#66A80F',
      900: '#5C940D'
    },
    yellow: {
      50: '#FFF9DB',
      100: '#FFF3BF',
      200: '#FFEC99',
      300: '#FFE066',
      400: '#FFD43B',
      500: '#FCC419',
      600: '#FAB005',
      700: '#F59F00',
      800: '#F08C00',
      900: '#E67700'
    },
    orange: {
      50: '#FFF4E6',
      100: '#FFE8CC',
      200: '#FFD8A8',
      300: '#FFC078',
      400: '#FFA94D',
      500: '#FF922B',
      600: '#FD7E14',
      700: '#F76707',
      800: '#E8590C',
      900: '#D9480F'
    },
    primary: {
      light: '#CCE5FF',
      main: '#036DEB',
      dark: '#0360CE',
      contrastText: '#FFFFFF'
    },
    secondary: {
      light: '#FFF',
      main: '#F6F6F6',
      dark: '#E8F1FA',
      contrastText: '#FFFFFF'
    },
    error: {
      light: '#FAEBEB',
      main: '#D83A52',
      dark: '#B63546',
      contrastText: '#FFFFFF'
    },
    warning: {
      light: '#FCF3E6',
      main: '#E16D0E',
      dark: '#A83F00',
      contrastText: '#222324'
    },
    info: {
      light: '#F1F7FF',
      main: '#2C99C1',
      dark: '#00708D',
      contrastText: '#222324'
    },
    success: {
      light: '#EFFBF5',
      main: '#258750',
      dark: '#007038',
      contrastText: '#FFFFFF'
    },
    divider: '#E6E9F0',
    background: {
      paper: '#FFFFFF',
      default: '#F9FAFC'
    },
    action: {
      hover: 'rgba(0, 0, 0, 0.04)',
      selected: 'rgba(54,112,184,0.04)',
      active: 'rgba(34,35,36,0.54)',
      disabled: 'rgba(171, 178, 195, 1)',
      disabledBackground: 'rgba(246, 246, 246, 1)',
      focus: 'rgba(0, 0, 0, 0.12)',
      backdrop: 'rgba(34, 35, 36, 0.12)',
      highlight: {
        strong: 'rgba(255, 245, 0, 0.16)',
        subtle: 'rgba(34, 35, 36, 0.05)'
      }
    },
    premium: {
      main: '#F3B22B'
    },
    new: {
      main: '#6D2FF0'
    },
    dataVisualization: {
      common: {
        nonOrganic,
        organic: '#5FCF66',
        others: '#DDDDDD'
      },
      colors: [
        nonOrganic,
        '#66D9E8',
        '#AF3ECA',
        '#92A8F9',
        '#F9C752',
        '#33C180',
        '#EB658B',
        '#EB7E30',
        '#FDAE33',
        '#039587',
        '#1453B6',
        '#56008C',
        '#8B572A'
      ]
    },
    stateVisualization: {
      black: '#220D4E',
      green: '#1EFFAE',
      violet: '#E1D3FF',
      white: '#FFFFFF',
      darkGrey: '#C6C1D2',
      backgroundGrey: '#F2F3F5'
    }
  }
};
